(function () {
  'use strict';
  const cards = [...document.querySelectorAll('[data-dw-cart-preview]')];
  if (!cards.length) return;
  const width = 1240, height = 1754;

  function makeMap(pixels, config) {
    const total = width * height, labels = new Int32Array(total), blocked = new Uint8Array(total), queue = new Int32Array(total), components = [];
    for (let i = 0, p = 0; i < total; i++, p += 4) if (Math.min(pixels[p], pixels[p + 1], pixels[p + 2]) < 80) blocked[i] = 1;
    const original = blocked.slice();
    for (let i = 0; i < total; i++) if (original[i]) {
      const x = i % width, y = (i / width) | 0;
      for (let dy = -2; dy <= 2; dy++) for (let dx = -2; dx <= 2; dx++) if (dx * dx + dy * dy <= 4) {
        const xx = x + dx, yy = y + dy;
        if (xx >= 0 && xx < width && yy >= 0 && yy < height) blocked[yy * width + xx] = 1;
      }
    }
    let next = 0;
    for (let i = 0; i < total; i++) {
      if (labels[i] || blocked[i]) continue;
      const p = i * 4;
      if (Math.min(pixels[p], pixels[p + 1], pixels[p + 2]) < config.whiteThreshold) continue;
      const id = ++next; let head = 0, tail = 0; queue[tail++] = i; labels[i] = id;
      while (head < tail) {
        const at = queue[head++], x = at % width, y = (at / width) | 0;
        for (const n of [x ? at - 1 : -1, x < width - 1 ? at + 1 : -1, y ? at - width : -1, y < height - 1 ? at + width : -1]) {
          if (n < 0 || labels[n] || blocked[n]) continue;
          const q = n * 4;
          if (Math.min(pixels[q], pixels[q + 1], pixels[q + 2]) >= config.whiteThreshold) { labels[n] = id; queue[tail++] = n; }
        }
      }
      components[id] = id;
    }
    const owners = new Map(), expanded = new Int32Array(labels);
    for (const segment of config.segments) {
      for (const [x, y] of segment.seeds) {
        const id = labels[y * width + x];
        if (!id || id === 1) continue;
        if (owners.has(id) && owners.get(id) !== segment.owner) throw new Error('A region is mapped to more than one color area.');
        owners.set(id, segment.owner);
      }
    }
    for (let pass = 0; pass < 2; pass++) {
      const prior = new Int32Array(expanded);
      for (let i = 0; i < total; i++) {
        if (prior[i]) continue;
        const p = i * 4, min = Math.min(pixels[p], pixels[p + 1], pixels[p + 2]), max = Math.max(pixels[p], pixels[p + 1], pixels[p + 2]);
        if (min < 100 || max - min > 30) continue;
        const x = i % width, y = (i / width) | 0; let found = 0, conflict = false;
        for (const n of [x ? i - 1 : -1, x < width - 1 ? i + 1 : -1, y ? i - width : -1, y < height - 1 ? i + width : -1, x && y ? i - width - 1 : -1, x < width - 1 && y ? i - width + 1 : -1, x && y < height - 1 ? i + width - 1 : -1, x < width - 1 && y < height - 1 ? i + width + 1 : -1]) {
          if (n < 0 || !owners.has(prior[n])) continue;
          if (found && found !== prior[n]) conflict = true;
          found = prior[n];
        }
        if (found && !conflict) expanded[i] = found;
      }
    }
    return { expanded, owners };
  }

  function render(canvas, snapshot, config, image) {
    const source = document.createElement('canvas'); source.width = width; source.height = height;
    const sourceContext = source.getContext('2d', { willReadFrequently: true });
    sourceContext.drawImage(image, 0, 0, width, height);
    const pixels = sourceContext.getImageData(0, 0, width, height).data;
    const map = makeMap(pixels, config), colorsByOwner = new Map(snapshot.regions.map(region => [region.id, region.hex]));
    const labels = map.expanded, colors = new Map();
    map.owners.forEach((owner, label) => {
      const hex = colorsByOwner.get(owner); if (!hex) return;
      const match = hex.match(/^#([a-f\d]{6})$/i); if (!match) return;
      colors.set(label, [parseInt(match[1].slice(0, 2), 16), parseInt(match[1].slice(2, 4), 16), parseInt(match[1].slice(4, 6), 16), 255]);
    });
    canvas.width = width; canvas.height = height;
    const ctx = canvas.getContext('2d'), frame = ctx.createImageData(width, height);
    for (let i = 0, p = 0; i < labels.length; i++, p += 4) {
      const color = colors.get(labels[i]); if (!color) continue;
      frame.data[p] = color[0]; frame.data[p + 1] = color[1]; frame.data[p + 2] = color[2]; frame.data[p + 3] = 255;
    }
    ctx.putImageData(frame, 0, 0);
  }

  async function renderCard(card) {
    const status = card.querySelector('[data-dw-preview-status]'), canvas = card.querySelector('canvas');
    const retry = card.querySelector('[data-dw-preview-retry]');
    if (retry) { retry.hidden = true; retry.disabled = true; }
    card.classList.remove('has-preview-error');
    try {
      const snapshot = JSON.parse(card.querySelector('[data-dw-design]').dataset.dwDesign);
      const response = await fetch(card.dataset.configUrl, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('The region map could not be loaded.');
      const config = await response.json();
      const image = new Image(); image.crossOrigin = 'anonymous'; image.src = card.dataset.artworkUrl;
      await new Promise((resolve, reject) => { image.onload = resolve; image.onerror = () => reject(new Error('The color artwork could not be loaded.')); });
      render(canvas, snapshot, config, image);
      status.textContent = 'Your saved color design';
      card.classList.add('is-rendered');
      if (retry) retry.remove();
    } catch (error) {
      status.textContent = 'Design preview unavailable. Your color choices are still saved with this cart item.';
      card.classList.add('has-preview-error');
      if (retry) { retry.hidden = false; retry.disabled = false; }
      console.warn('Dream Whisper cart preview:', error);
    }
  }

  cards.forEach(card => {
    const retry = card.querySelector('[data-dw-preview-retry]');
    if (retry) retry.addEventListener('click', () => renderCard(card));
    renderCard(card);
  });

  document.querySelectorAll('[data-dw-remove]').forEach(button => button.addEventListener('click', async () => {
    button.disabled = true; button.textContent = 'Removing…';
    try {
      const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: button.dataset.lineKey, quantity: 0 }) });
      if (!response.ok) throw new Error('Shopify could not remove this item.');
      location.reload();
    } catch (error) { button.disabled = false; button.textContent = 'Remove customized item'; window.alert(error.message); }
  }));
})();
